import React from 'react'
import './PageWrapper.scss'

export default function PageWrapper({bgColor = 'white', style, classes, children}) {
    return (
        <div className={`pageContentWrapper ${classes}`}  style={{backgroundColor: bgColor, ...style}}>
            <div className='pageContent'>
                {children}
            </div>
        </div>
    )
}
